import { render } from "./UploadSolicitudes.vue?vue&type=template&id=2888bb56"
import script from "./UploadSolicitudes.vue?vue&type=script&lang=js"
export * from "./UploadSolicitudes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__